import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box } from '@applyboard/ui-components';
import GradeConversionInfo from "../GradeConversionInfo";
import NumberInput from "../NumberInput";
import SelectComponentV2 from "../../SelectComponentV2";
import { validateGrade, validateMax } from "./validators";
import { GRADING_AVERAGE_LABEL, GRADING_SCALE_LABEL, SCALE_OPTIONS } from "./consts";
import { scrollIfNeeded } from "../../../Utilities/Helper";

// Copied from OTHER_OPTIONS in packages/ab-common/src/constants/consts.ts
// Someday, this list should be centralized and shared between packages.

function OtherGradeForm(_ref) {
  var grade = _ref.grade,
    max = _ref.gradeMax,
    id = _ref.id,
    onSubmit = _ref.onSubmit,
    formValidated = _ref.formValidated;
  var _useState = useState(grade),
    _useState2 = _slicedToArray(_useState, 2),
    gradeValue = _useState2[0],
    setGradeValue = _useState2[1];
  var _useState3 = useState(validateGrade(gradeValue, max)),
    _useState4 = _slicedToArray(_useState3, 2),
    gradeError = _useState4[0],
    setGradeError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    gradeTouched = _useState6[0],
    setGradeTouched = _useState6[1];
  var _useState7 = useState(max),
    _useState8 = _slicedToArray(_useState7, 2),
    maxValue = _useState8[0],
    setMaxValue = _useState8[1];
  var _useState9 = useState(validateMax(maxValue)),
    _useState10 = _slicedToArray(_useState9, 2),
    maxError = _useState10[0],
    setMaxError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    maxTouched = _useState12[0],
    setMaxTouched = _useState12[1];
  function process(newGradeValue, newMaxValue) {
    setGradeValue(newGradeValue);
    var newGradeError = validateGrade(newGradeValue, newMaxValue);
    setGradeError(newGradeError);
    setMaxValue(newMaxValue);
    var newMaxError = validateMax(newMaxValue);
    setMaxError(newMaxError);
    var valid = newGradeError === '' && newMaxError === '';
    if (!valid) {
      onSubmit('', '');
    } else {
      onSubmit(newGradeValue, newMaxValue);
    }
  }
  function handleGradeChange(event) {
    process(event.target.value, maxValue);
    setGradeTouched(true);
  }
  function handleMaxChange(event) {
    process(gradeValue, event.target.value);
    setMaxTouched(true);
  }
  function handleSubmit(event) {
    event.preventDefault();
    if (gradeError || maxError) {
      setGradeTouched(true);
      setMaxTouched(true);
    } else {
      onSubmit(gradeValue, String(maxValue));
    }
  }
  var averageRef = useCallback(function (node) {
    return scrollIfNeeded(node);
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    id: id,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    pb: "16px"
  }, /*#__PURE__*/React.createElement(SelectComponentV2, {
    error: maxError,
    id: "".concat(id, "-select"),
    label: GRADING_SCALE_LABEL,
    onBlur: function onBlur() {
      setMaxTouched(true);
    },
    onChange: handleMaxChange,
    options: SCALE_OPTIONS,
    touched: maxTouched || formValidated,
    value: maxValue
  })), !maxError && /*#__PURE__*/React.createElement(Box, {
    pb: "16px",
    ref: averageRef
  }, /*#__PURE__*/React.createElement(NumberInput, {
    error: gradeError,
    id: "".concat(id, "-input"),
    label: GRADING_AVERAGE_LABEL,
    onBlur: function onBlur() {
      setGradeTouched(true);
    },
    onChange: handleGradeChange,
    touched: gradeTouched || formValidated,
    value: gradeValue
  }), /*#__PURE__*/React.createElement(GradeConversionInfo, null)));
}
export default OtherGradeForm;